import { useState, useEffect, useContext } from "react";
import { AuthContext } from "context/AuthContext";
import clsx from "clsx";
import { SvgLogo } from "ui/svgs";
import {
  formatMinute,
  formatCaseStatusSDKToDisplay,
  formatAlertTagSDKToDisplayWithDesc,
  getCaseStatusStyles,
} from "lib/utils";
import { Tooltip, Radio } from "antd";
import { CASE_STATUS_SDK, INVESTIGATE_TAG_SDK, USER_ROLE } from "lib/constants";
import { useService } from "pages/dashboard/alerts/service";
import { CaseInfoType } from "lib/types";

export default function CaseItem(props: {
  dataCase: CaseInfoType;
  index: number;
  setCheckedCaseIndex: (index: number) => void;
  checked: boolean;
}) {
  const { privileges } = useContext(AuthContext);
  const { dataCase, setCheckedCaseIndex, checked, index } = props;
  const { getSnapShotByAlertObj, getTargetImgByAlertObj } = useService();
  const [snapShotSrc, setSnapShotSrc] = useState(null);
  const [targetImgSrc, setTargetImgSrc] = useState(null);

  useEffect(() => {
    if (!dataCase) {
      return;
    }

    getSnapShotByAlertObj(dataCase?.alerts?.at(0), { case_id: dataCase?.id })
      .then((data) => {
        setSnapShotSrc(URL.createObjectURL(data));
      })
      .catch((e) => console.error(e));

    getTargetImgByAlertObj(dataCase?.alerts?.at(0), { case_id: dataCase?.id })
      .then((data) => {
        setTargetImgSrc(URL.createObjectURL(data));
      })
      .catch((e) => console.error(e));
  }, [dataCase]);

  const isCaseDealer = privileges.includes("caseDealer");

  return (
    <div className="pt-4">
      <div
        onClick={() => setCheckedCaseIndex(index)}
        className={clsx(
          "focus:outline-none py-[18px] pl-5 pr-4 cursor-pointer rounded-2xl bg-[#F6F8FC] border-[2px] border-transparent hover:border-[#3E83F6] ",
        )}
      >
        <div className="w-full flex items-center gap-3 ">
          <Radio checked={checked} />
          <Tooltip
            arrow={false}
            placement="right"
            overlayInnerStyle={{ padding: "0px" }}
            title={
              targetImgSrc && (
                <div>
                  <img
                    src={targetImgSrc}
                    className="max-w-full max-h-full !rounded-lg"
                  />
                </div>
              )
            }
          >
            <div className="relative rounded-lg h-[80px] aspect-video flex-shrink-0 flex items-center justify-center bg-zinc-100 border">
              {snapShotSrc ? (
                <img
                  src={snapShotSrc}
                  alt="Camera Snapshot"
                  className="aspect-video rounded-lg object-cover"
                />
              ) : (
                <SvgLogo width="28" className="fill-zinc-400" />
              )}
            </div>
          </Tooltip>
          <div className="flex flex-col justify-between flex-grow h-[80px]">
            <div className="flex justify-between w-full text-neutral-500 text-sm">
              <span className="max-w-[110px] text-base overflow-hidden break-words text-nowrap text-ellipsis break-all font-medium text-neutral-800">
                {dataCase?.displayId}
              </span>
              <p>{formatMinute(parseInt(dataCase.createdAt))}</p>
            </div>
            <div className="flex justify-between w-full text-xs font-semibold">
              <p
                className="text-nowrap text-ellipsis px-1 rounded relative -left-1 font-semibold"
                style={getCaseStatusStyles(dataCase?.status as CASE_STATUS_SDK)}
              >
                {formatCaseStatusSDKToDisplay(
                  dataCase?.status as CASE_STATUS_SDK,
                )}
              </p>
              <p className="bg-[#EEEEEE] text-neutral-500 rounded px-1 max-w-[100px] text-nowrap overflow-hidden  break-all break-words text-ellipsis">
                {formatAlertTagSDKToDisplayWithDesc(
                  dataCase?.tag?.name as INVESTIGATE_TAG_SDK,
                  dataCase?.tag.desc,
                )}
              </p>
            </div>
            {isCaseDealer && (
              <p className="text-sm max-w-[200px] text-neutral-500 overflow-hidden break-all break-words text-nowrap text-ellipsis">
                {dataCase?.customer?.accountName || "-"}
              </p>
            )}

            <p className="text-sm max-w-[200px] text-neutral-500 overflow-hidden break-all break-words text-nowrap text-ellipsis">
              {dataCase.alerts?.at(0)?.site?.name}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
